import { render, staticRenderFns } from "./SubmissionHeader.vue?vue&type=template&id=d0a6e20c&scoped=true&"
import script from "./SubmissionHeader.vue?vue&type=script&lang=js&"
export * from "./SubmissionHeader.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionHeader.vue?vue&type=style&index=0&id=d0a6e20c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a6e20c",
  null
  
)

export default component.exports